<template>
  <div class>
    <STable
        ref="tableref"
        :url="url"
        :selection="false"
        :columns="columns"
        :handle="handle"
        :query="query"
        labelWidth="100px"
        cnames="通知接收人"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "gaojingtongzhijilu",
  components: {},
  data() {
    return {
      url: "/alarm/alarmKSD/page",
      columns: [
            {
          label: "电枪名称",
          prop: "connectorName",
            template:(index,record)=>{
            return record.connector.connectorName
          }
        },
        {
          label: "电枪编码",
          prop: "connectorID",
          template:(index,record)=>{
            return record.connector.connectorID
          }
        },
               {
          label: "告警点",
          prop: "alarmPointAttr"
        },
        {
          label: "告警原因",
          prop: "reasonAttr"
        },
        {
          label: "持续时间（s）",
          prop: "duration"
        },
        {
          label: "创建时间",
          prop: "createDate"
        },
        // {
        //   label: "品牌",
        //   prop: "equipmentModel"
        // },

      ],

      // 操作栏
      handle: {
        width: 100,
        btns: [
        {
            label: "查看",
            permission: "",
            handle: resp => {
            }
        }
        ]
      },
      query: [
        {
          label: "电枪编码",
          prop: "connectorID",
          placeholder: "请输入电枪编码",
        },
        {
          label: "开始时间",
          prop: "startTime",
          placeholder: "",
          type: "date2",
        },

      ],
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/keshidaRecord.vue